import { render } from "./SeeOtherLuxury.vue?vue&type=template&id=79852bee&scoped=true"
import script from "./SeeOtherLuxury.vue?vue&type=script&lang=js"
export * from "./SeeOtherLuxury.vue?vue&type=script&lang=js"

import "./SeeOtherLuxury.scss?vue&type=style&index=0&id=79852bee&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79852bee"]])

export default __exports__